import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { adminRoles, userRoles } from './services/auth/access-roles';
import { AuthGuard } from './services/auth/auth-guards';
import { AuthorizationGuard } from './services/auth/authorization-guards';

const routes: Routes = [
  {
    path: 'dpp/weight-balance',
    canActivate: [AuthGuard, AuthorizationGuard],
    data: {
      accessroles: userRoles
    },
    loadChildren: () =>
      import('./views/weight-balance/weight-balance.module').then(
        mod => mod.WeightBalanceModule
      ),
  },
  {
    path: 'dpp/status',
    canActivate: [AuthGuard, AuthorizationGuard],
    data: {
      accessroles: userRoles
    },
    loadChildren: () =>
      import('./views/status/status.module').then(mod => mod.StatusModule),
  },
  {
    path: 'dpp/history',
    canActivate: [AuthGuard, AuthorizationGuard],
    data: {
      accessroles: userRoles
    },
    loadChildren: () =>
      import('./views/history/history.module').then(mod => mod.HistoryModule)
  },
  {
    path: 'dpp/config',
    canActivate: [AuthGuard, AuthorizationGuard],
    data: {
      accessroles: adminRoles
    },
    loadChildren: () =>
      import('./views/configurations/configurations.module').then(
        mod => mod.ConfigurationsModule)
  },
  {
    path: '', pathMatch: 'full', redirectTo: 'dpp/status', canActivate: [AuthGuard, AuthorizationGuard]
  },
  {
    path: 'weight-balance', pathMatch: 'full', redirectTo: 'dpp/weight-balance', canActivate: [AuthGuard, AuthorizationGuard]
  },
  {
    path: 'status', pathMatch: 'full', redirectTo: 'dpp/status', canActivate: [AuthGuard, AuthorizationGuard]
  },
  {
    path: 'dpp', pathMatch: 'full', redirectTo: 'dpp/status', canActivate: [AuthGuard, AuthorizationGuard]
  },
  {
    path: 'auth-callback', redirectTo: '', pathMatch: 'full'
  },
  { 
    path: 'access-denied', pathMatch: 'full', component: AccessDeniedComponent 
  },
  {
    path: '**', redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
